import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { EmpDetailsService } from '../../../Model/EmpProfileDetails/emp-details.service';

@Component({
  selector: 'app-view-profile-request-detail',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, DataTablesModule],
  templateUrl: './view-profile-request-detail.component.html',
  styleUrl: './view-profile-request-detail.component.scss'
})
export class ViewProfileRequestDetailComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;
  public user: any = null;
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(public activeModal: NgbActiveModal,
    protected common: CommonService,
    private session: SessionService,
    private router: Router,
    private EmpDetail: EmpDetailsService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.EmpProfile_InfoDocDetails();
  }
  EmpProfile_InfoDocDetails() {
    this.isDisabled = true
    this.EmpDetail.EmpProfile_InfoDocDetails({ OperationType: this.InputData.OperationType, EmpMasterId: this.InputData.EmpMasterId, ESS_EmpProfileUpdateRequestID: this.InputData.ESS_EmpProfileUpdateRequestID }).subscribe({
      next: (data) => {
        //this.EmpOldDocDetail = data.Table;
        this.TableDatas = data.Table1;
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }
  Cancel() {
    this.activeModal.close();
  }
}
